import { render } from "./EventInvitationPreview.vue?vue&type=template&id=7dc35a7c"
import script from "./EventInvitationPreview.vue?vue&type=script&lang=js"
export * from "./EventInvitationPreview.vue?vue&type=script&lang=js"

import "./EventInvitationPreview.vue?vue&type=style&index=0&id=7dc35a7c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__